import * as React from 'react';
import * as ReactDOM from 'react-dom';
import './index.css';

import SimulationComponent from "./components/SimulationComponent/index";

import { BrowserRouter as Router, Route } from 'react-router-dom'
import {Redirect} from "react-router";
import Testing from "./components/Testing";
import FullStoryManager from "./fbobjects/FullStoryManager";
import KillPageStore from "./fbobjects/KillPageStore";

KillPageStore.actionPageLoadingStart()





ReactDOM.render(

	<Router>
		<div>
			<Route exact path="/" render={()=>(<Redirect to="/simulation"/>)}/>
			<Route path="/simulation/:id?" component={SimulationComponent as any} />
			<Route path="/test" component={Testing as any} />
		</div>
	</Router>
  ,
  document.getElementById('root')
);



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/index.tsx